module.exports = __webpack_public_path__ + "img/3.4c3a3fb4.jpg";